export default {
    API_ENDPOINT: 'https://floating-citadel-93144.herokuapp.com/api',
    TOKEN_KEY: 'medigenda-client-auth-token',
  }
  